import type { I18nFn } from 'i18n/types/I18nFn';

export const SearchEventRefinement = {
  ACTION_DATE: 'actionDate',
  AREAS_OF_FOCUS: 'areasOfFocus',
  LOCATION_TYPE: 'locationType',
  LOCALE: 'locale',
  RADIUS: 'radius',
  SOURCE: 'source',
  RECENCY: 'recency',
  IDEALIST_DAYS: 'isIdealistDay', // this could be extended to multiple options, is a single toggle for now
} as const;

export const SEARCH_EVENT_REFINEMENT_NAMES = Object.values(
  SearchEventRefinement,
);

export function SEARCH_EVENT_REFINEMENT_LABELS(i18n: I18nFn) {
  return {
    [SearchEventRefinement.AREAS_OF_FOCUS]: i18n('Cause Areas'),
    [SearchEventRefinement.ACTION_DATE]: i18n('Date'),
    [SearchEventRefinement.LOCALE]: i18n('Listing Language'),
    [SearchEventRefinement.IDEALIST_DAYS]: i18n('Show only Idealist Days'),
    [SearchEventRefinement.LOCATION_TYPE]: i18n('Location Type'),
    [SearchEventRefinement.SOURCE]: i18n('Source'),
    [SearchEventRefinement.RADIUS]: i18n('Radius'),
    [SearchEventRefinement.RECENCY]: i18n('Recency'),
  } as Record<SearchEventRefinementType, string>;
}

export type SearchEventRefinementType =
  (typeof SearchEventRefinement)[keyof typeof SearchEventRefinement];
